export const VERSION = "v4.18.0";
